import { useDispatch } from "react-redux";

import { useMount } from "app/custom-hooks/useMount";
import { TypeOfSelectors } from "app/pages/sales-intelligence/common-components/MultiSelector/types";
import { fetchExcelQuotaThunk } from "app/pages/sales-intelligence/sub-modules/common/store/effects";
import type { TableActionProps } from "app/pages/sales-intelligence/sub-modules/table-actions-panel/components/TableActionsPanel/types";

import WebsitesExportOptionsDropdownContainer from "../../../../company-search/containers/WebsitesExportOptionsDropdown/WebsitesExportOptionsDropdownContainer";
import LandscapeWebsitesExcelExportPanelContainer from "../ActivatedExportPanel/ExcelCompetitiveExportPanelContainer";
import DynamicsLandscapeWebsitesExportPanelContainer from "../ActivatedExportPanel/DynamicsCompetitiveExportPanelContainer";
import HubSpotLandscapeWebsitesExportPanelContainer from "../ActivatedExportPanel/HubSpotCompetitiveExportPanelContainer";
import SalesforceLandscapeWebsitesExportPanelContainer from "../ActivatedExportPanel/SalesforceCompetitiveExportPanelContainer";

const ExportCompetitiveButtonContainer = (props: TableActionProps) => {
    const dispatch = useDispatch();

    useMount(() => {
        dispatch(fetchExcelQuotaThunk());
    });

    function handleSelect(variant: TypeOfSelectors) {
        switch (variant) {
            case TypeOfSelectors.EXCEL:
                return props.onActivate(() => LandscapeWebsitesExcelExportPanelContainer);
            case TypeOfSelectors.EXPORT_SALES_FORCE:
                return props.onActivate(() => SalesforceLandscapeWebsitesExportPanelContainer);
            case TypeOfSelectors.EXPORT_HUBSPOT:
                return props.onActivate(() => HubSpotLandscapeWebsitesExportPanelContainer);
            case TypeOfSelectors.EXPORT_DYNAMICS:
                return props.onActivate(() => DynamicsLandscapeWebsitesExportPanelContainer);
            default:
                return undefined;
        }
    }

    return (
        <WebsitesExportOptionsDropdownContainer
            isDisabled={props.isDisabled}
            onOptionSelect={handleSelect}
        />
    );
};

export default ExportCompetitiveButtonContainer;
